import React, { createContext, useState } from 'react';

type ModalData = {
  switchModalVisibility: () => void;
  setModalVisibility: (x: boolean) => void;
  visibility: boolean;
};

export const ModalContext = createContext<ModalData>({} as ModalData);

export const ModalProvider: React.FC = ({ children }) => {
  const [visibility, setVisibility] = useState(false);

  const switchModalVisibility = () => {
    setVisibility(!visibility);
  };

  const setModalVisibility = (visible: boolean) => {
    setVisibility(visible);
  };

  return (
    <ModalContext.Provider
      value={{ switchModalVisibility, setModalVisibility, visibility }}
    >
      {children}
    </ModalContext.Provider>
  );
};
